import { render, staticRenderFns } from "./LookBookTopicEdit.vue?vue&type=template&id=3610d240&"
import script from "./LookBookTopicEdit.vue?vue&type=script&lang=js&"
export * from "./LookBookTopicEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports